import { render, staticRenderFns } from "./BreakoutHistoryTemplate.vue?vue&type=template&id=4d6910ae"
import script from "./BreakoutHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./BreakoutHistoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports